import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemText, ListItemSecondaryText, ListItemMeta, ListItemGraphic } from 'rmwc';
import { includes } from 'lodash';
import { Text } from '../Text';

export const CheckboxListControl = ({ spec, values, onChange }) => {
  return (
    <List twoLine={true}>
      {spec.options.map(opt => {
        const selected = includes(values, opt);

        return (
          <ListItem
            theme={selected && 'secondary'}
            key={`opt-${opt}`}
            selected={selected}
            onClick={event => onChange(opt, !selected)}
          >
            <ListItemText>
              {spec.option_data[opt].label}
              <ListItemSecondaryText>{spec.option_data[opt].description}</ListItemSecondaryText>
            </ListItemText>
            <ListItemMeta theme={selected && 'secondary'} className="hrbr-clickable">
              {selected ? 'check_box' : 'check_box_outline_blank'}
            </ListItemMeta>
          </ListItem>
        );
      })}
    </List>
  );
};

CheckboxListControl.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

export default CheckboxListControl;
